module.exports = __webpack_public_path__ + "img/Pro-2.86e4ca7a.jpg";